import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import {finalize, of, switchMap, take} from 'rxjs';
import { ContractsApiService } from 'src/app/core/services/api/contracts-api.service';
import { ApiResponse } from '../../models/api-response.interface';
import { Contract } from '../../models/contract.interface';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-approve-cancellation',
  templateUrl: './approve-cancellation.component.html',
  styleUrls: ['./approve-cancellation.component.css']
})
export class ApproveCancellationComponent implements OnInit {
  contract!: Contract;
  isLoading: boolean = false;
  isError: boolean = false;
  cancelId:any;
  constructor(private contractService: ContractsApiService,
              private route: ActivatedRoute,
              private notificationService: NotificationsService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.route.params
      .pipe(
        take(1),
        switchMap((params: Params) => {
          return of(this.cancelId= params['id']);
        }),
        switchMap((result: ApiResponse) => {
          this.contract = result.data;
          return this.route.queryParams;
        }),
        switchMap((params: Params) =>
          this.contractService.approveCancellation(this.cancelId, params['approveToken'])))
      .subscribe({
        next: (result: ApiResponse) => {
          this.isLoading = false;
          this.notificationService.success('Success', result.message)
        },
        error: ({ error }) => {
          this.isLoading = false;
          this.isError = true;
          this.notificationService.error('Error', error.message)
        },
      });
  }

}
